import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AuditChangesComponent } from './auditchanges.component';

const routes: Routes = [
  { path: '', component: AuditChangesComponent, data: { title: 'Change Log' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuditChangesRoutingModule {}

@NgModule({
  imports: [
    AuditChangesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [AuditChangesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuditChangesModule {}
